import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { registerServiceWorker } from './pwa/register';
import { AppShell } from './routes/AppShell';
import './theme.css';

const container = document.getElementById('root');
if (container === null) {
  throw new Error('#root is missing from index.html');
}

createRoot(container).render(
  <StrictMode>
    <AppShell />
  </StrictMode>,
);

// Installability and the offline shell. A no-op in development, and it decides
// for itself when the first paint can spare the bandwidth.
registerServiceWorker();
